import React, { useContext, useEffect, useState } from "react";
import AddLaboratory from "../admin/manageWebsite/lab/AddLaboratoryGuideline";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader from "../pageheader/PageHeader";
import Breadcrumb from "../public/breacrumb/breadcrumb";
import Footer from "../footer/Footer";
import HeadBar from "../../component/public/headBar/HeadBar";

import { CurrentUserContext } from "../../App";
import { RedirectCode400 } from "../RedirectCode400";
import TinyMCE from "../material/tinymce/TinyMCE";
import Datepicker from "../material/datepicker/Datepicker";
import ToggleCheckbox from "../material/toggleCheckbox/ToggleCheckbox";
// import * as medicalApi from '../../service/medicalApi'

import * as labApi from "../../service/labPersonalApi";

const GuidelineForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setIsMessage } = useContext(CurrentUserContext);

  const [loading, setLoading] = useState(false);
  const [titleValue, setTitleValue] = useState("");
  const [detailValue, setDetailValue] = useState(location.state?.detail ?? "");
  const [publishStartDate, setPublishStartDate] = useState(
    location.state?.publishStartDate ?? "",
  );
  const [publishEndDate, setPublishEndDate] = useState(
    location.state?.publishEndDate ?? "",
  );
  const [active, setActive] = useState(location.state?.active ?? true);
  const [pined, setPined] = useState(location.state?.pined ?? false);
  const [title, setTitle] = useState(location.state?.title ?? "");

  let textTitlePage = "แนวทางการตรวจ";
  if (location.state?.type) {
    //setTitleValue(location.state?.type)
    if (location.state?.type === "add") {
      textTitlePage = "เพิ่มแนวทางการตรวจ";
    }
    // console.log("state:", location.state?.type)
  }

  useEffect(() => {
    setTitleValue("guideline");
  }, []);

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "แนวทางการตรวจ/เอกสารที่เกี่ยวข้อง", url: "/inspectionGuide" },
    { name: textTitlePage, url: "/guidelineForm" },
  ];

  //Function

  const addGuideline = async () => {
    setLoading(true);
    let res = await labApi.addGuideline(
      titleValue,
      title,
      detailValue,
      pined,
      active,
      publishStartDate,
      publishEndDate,
    );
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/inspectionGuide", {
          state: {
            type: "guide",
          },
        });
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        // console.log(res["data"]["message_th"] || res["data"]["message"]);
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const updateGuideline = async () => {
    setLoading(true);
    let res = await labApi.updateGuideline(
      location.state?.guideline_id,
      titleValue,
      title,
      detailValue,
      pined,
      active,
      publishStartDate,
      publishEndDate,
    );
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/inspectionGuide", {
          state: {
            type: "guide",
          },
        });
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const onClickAddSubmit = () => {
    if (!titleValue) {
      setIsMessage({ type: "warning", data: "กรุณากรอกหัวข้อ" });
    } else if (!detailValue) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรายละเอียด" });
    } else if (!publishStartDate) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกวันที่เผยแพร่" });
    } else {
      if (location.state?.type === "add") {
        addGuideline();
      } else if (location.state?.type === "edit") {
        updateGuideline();
      } else {
        setIsMessage({
          type: "warning",
          data: "ไม่สามารถบันทึกข้อมูลแนวทางการตรวจ",
        });
      }
    }
  };

  return (
    <>
      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />
        <PageHeader titlename={textTitlePage} />

        <div>
          <div className="flex flex-row justify-center items-start md:flex-col w-full gap-[20px]">
            <div className="rounded-[6px] border-[#E2E2E4] border w-[70%] md:w-[100%] p-[9px_16px]">
              <div className="flex flex-col text-[16px] font-['Prompt']">
                หัวข้อ
                <input
                  type="text"
                  className="border border-solid border-[#E0DFE2] rounded-lg md:text-[14px] text-[#000000] p-2 focus:outline-none md:mt-0 md:mb-0 mt-1 mb-4 w-full h-[38px]"
                  placeholder=""
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
              <div>
                <div className="md:text-[14px] text-[16px] text-[#000000] md:my-1 my-3 font-['Prompt']">
                  รายละเอียด
                </div>

                <TinyMCE
                  readOnly={false}
                  value={detailValue}
                  setValue={setDetailValue}
                />
              </div>
            </div>
            <div className="md:w-full">
              <div className="rounded-[6px] border-[#E2E2E4] border w-[100%] md:w-[100%] p-[9px_16px]">
                {/* enable check edit  */}
                {/* <div className="flex flex-col gap-[8px] font-['Prompt'] text-[16px] mb-[10px]">
                                    ปักหมุด
                                    <ToggleCheckbox label="" value={pined} setValue={setPined} />
                                </div> */}
                <div className="flex flex-col mt-4 font-['Prompt'] text-[16px] mb-[10px]">
                  วันที่เเสดง
                  <Datepicker
                    label=""
                    value={publishStartDate}
                    setValue={setPublishStartDate}
                    className="md:text-[14px] text-xl text-[#000000] font-['Prompt'] text-[16px]"
                    title="publicity"
                  ></Datepicker>
                </div>
                <div className="flex flex-col mt-4 font-['Prompt'] text-[16px] mb-[10px]">
                  วันที่หมดอายุ
                  <Datepicker
                    label=""
                    value={publishEndDate}
                    setValue={setPublishEndDate}
                    className="md:text-[14px] text-xl text-[#000000] font-['Prompt'] text-[16px]"
                    title="publicity"
                  ></Datepicker>
                </div>
                <div className="flex flex-col gap-[8px] mt-4 font-['Prompt'] text-[16px] mb-[10px]">
                  สถานะที่เผยเเพร่
                  <ToggleCheckbox
                    label=""
                    value={active}
                    setValue={setActive}
                  />
                </div>
              </div>
              <div className="flex flex-row gap-3 justify-end items-center mt-[10px] md:justify-center">
                <button
                  onClick={() => {
                    navigate("/guidelineForm");
                  }}
                  className="button-theme-pg flex justify-center items-center w-[90px] h-[40px] bg-[#C0C0C0] rounded-[5px] gap-1 text-[#FFFFFF] "
                >
                  ยกเลิก
                </button>
                <button
                  onClick={() => {
                    onClickAddSubmit();
                  }}
                  className="button-theme-pg flex justify-center items-center w-[90px] h-[40px] bg-[#2EA669] rounded-[5px] gap-1 text-[#FFFFFF] "
                >
                  บันทึก
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuidelineForm;
